import React, { useEffect, useMemo, useRef, useState } from "react";
import { tableTypes } from "../../../../config/LiveStreamingConstants";
import Icon from "assets/icons";
import { BsPersonFillSlash } from "react-icons/bs";
import ClusterTable from "./ClusterTable";
import Participant from "../backup/Participant";
import ParticipantGridViewTable from "../backup/ParticipantGridViewTable";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store";
import Trainer from "../backup/Trainer";
import {
  IoMicOffOutline,
  IoMicOutline,
  IoVideocamOffOutline,
  IoVideocamOutline,
} from "react-icons/io5";
import RoomClient from "components/containers/utils/mediaSoup/RoomClient";
import LogoutControl from "../controls/Logout";
import { User } from "models/User";
import { groupBy, updateAudioByTable } from "utils/StreamingHelperFunctions";
import ParticipantExpandedView from "../backup/ParticipantExpandedView";

export const NoParticipantPanel = ({ name, height = 130, width = 192 }: any) => {
  const isMicOn = false;
  const isVideoOn = false;
  const getDimension = (dim: number | string | undefined, isWidth: boolean = false): string => {
    if (dim === undefined) return isWidth ? `${width}px` : `${height}px`;
    if (typeof dim === 'number') return `${dim}px`;
    return dim;
  };

  const containerWidth = getDimension(width, true);
  const containerHeight = getDimension(height);

  const getTailwindSize = (size: number | string, isWidth: boolean): string => {
    if (typeof size === 'string') return size; // Assume it's a Tailwind class
    const sizeMap: { [key: number]: string } = isWidth
      ? {
        192: 'w-48',
        128: 'w-32',
        256: 'w-64',
        320: 'w-80',
        384: 'w-96',
      }
      : {
        144: 'h-36',
        96: 'h-24',
        192: 'h-48',
        240: 'h-60',
        288: 'h-72',
      };
    return sizeMap[size] || (isWidth ? 'w-48' : 'h-36');
  };

  const containerClasses = [
    'relative flex justify-center items-center',
    getTailwindSize(width, true),
    getTailwindSize(height, false),
    'mobile:w-32 mobile:h-20',
    'tablet:w-40 tablet:h-24',
    'laptop:w-48 laptop:h-28',
    'desktop:w-48 desktop:h-28',
    'largescreen:w-48 largescreen:h-28',
    'relative bg-[#5B5D6B] bg-opacity-40 rounded-lg overflow-hidden flex items-center justify-center',
  ].join(' ');

  return (
    <div className={containerClasses}>
      <BsPersonFillSlash className="text-5xl mobile:text-3xl text-white mb-1" />
      <div className="absolute mobile:text-s bottom-1 right-1 px-2 py-0.5 rounded text-white text-xs truncate max-w-[70%]">
        {name || 'Trainee'}
      </div>
      <div className="absolute mobile:text-s bottom-1 left-1 px-2 py-0.5 rounded text-yellow-500 text-xs truncate max-w-[70%]">
        Yet to Join
      </div>
    </div>
  );
};

interface ClusterTableSittingAlignmentProps {
  session_id?: string;
  resSettings?: any;
  roomClient?: RoomClient | null; // Add roomClient to the interface
}

const ClusterTableSittingAlignment: React.FC<ClusterTableSittingAlignmentProps> = ({
  roomClient,
}) => {
  const [myStream, setMyStream] = useState<any>({})
  const [otherStream, setOtherStream] = useState<any>({})
  const [allStream, setAllStream] = useState<any>({})
  const { batch, mode } = useSelector((state: RootState) => state.live.settings);
  const consumers: any = useSelector(
    (state: RootState) => state.live.settings.consumers
  );
  const consumerPeersIds: any[] = useSelector(
    (state: RootState) => state.live.settings.consumerPeers
  );
  const peers: any = useSelector(
    (state: RootState) => state.live.settings.peersNew
  );

  const trainerJoinedtable = useSelector((state: RootState) => state.live.settings.trainerJoinedtable);
  const profileData = useSelector((state: any) => state?.auth?.user as User);
  const [view, setView] = useState(true);
  const tables = batch ? JSON.parse(batch?.sittingStyle[0].table) : [];
  const producers = useSelector(
    (state: RootState) => state.live.settings.producers
  );
  const auth = useSelector((state: RootState) => state.auth.user);
  const { trainer } = useSelector((state: RootState) => state.live.settings);
  const [selectedTable, setSelectedTable] = useState<any>(null);


  const myEmail = auth?.email;

  const sortedTables = useMemo(() => {
    if (!tables?.length || !profileData?.email) return tables;

    const myTable = tables.find((table) =>
      table.seats.some((seat: any) => seat.participant_email === profileData?.email)
    );
    const otherTables = tables.filter(
      (table) =>
        !table.seats.some((seat: any) => seat.participant_email === profileData?.email)
    );

    // Put myTable first if found
    return myTable ? [myTable, ...otherTables] : tables;
  }, [tables, profileData?.email]);

  useEffect(() => {
    const checkAllPeersPresent = (peerList: string[], audioConsumers: any[]) => {
      const audioConsumerIds = audioConsumers.map((a: any) => a.peerId);
      return peerList.every((peerId) => audioConsumerIds.includes(peerId));
    };

    const findPeers = async () => {
      if (roomClient && tables.length > 0 && myEmail) {
        // const peerList = Object.keys(peers);
        const currentState = roomClient?._store?.getState?.();
        const currentConsumers =
          currentState?.live?.settings?.consumers || {};

        const currentAudioConsumers = Object.values(currentConsumers).filter(
          (c: any) =>
            (c.track?.kind || c.kind) === "audio" &&
            c.track?.readyState === "live"
        );

        const audioConsumerIds = currentAudioConsumers.map((a: any) => a.peerId);
        // const allPresent = checkAllPeersPresent(peerList, currentAudioConsumers);

        // if (!allPresent) {
        //   setTimeout(findPeers, 300);
        //   return;
        // }

        // ✅ All peers are present — proceed
        console.log("✅ All peerIds found in audioConsumers");
        const muteStates = updateAudioByTable(
          tables,
          myEmail,
          "trainer@vtt",
          trainerJoinedtable,
          audioConsumerIds
        );
        console.log("muteStates:", muteStates);

        roomClient.consumerResumeRoleplayersAudio(muteStates.muteStates);
      }
    };
    findPeers();
  }, [consumerPeersIds, trainerJoinedtable]);

  const myTableEmails = useMemo(() => {
    if (!myEmail || !tables.length) return [];
    for (const tableData of tables) {
      const tableEmails = tableData.seats.map((seat: any) => seat.participant_email);
      if (tableEmails.includes(myEmail)) {
        return tableEmails;
      }
    }
    return [];
  }, [tables, myEmail]);
  const getTrack = (email: string) => {
    if (!consumers || !producers || !auth) {
      console.warn("No consumers, producers, or auth available");
      return { audio: null, video: null };
    }

    if (email === auth.email) {
      const validProducers = Object.values(producers).filter(
        (producer: any) => producer !== undefined
      );

      const videoProducer: any = validProducers.find(
        (producer: any) => producer?.kind === "video"
      );
      const audioProducer: any = validProducers.find(
        (producer: any) => producer?.kind === "audio"
      );

      return {
        audio: audioProducer
          ? { track: audioProducer.track, locallyPaused: audioProducer.paused }
          : null,
        video: videoProducer
          ? { track: videoProducer.track, locallyPaused: videoProducer.paused }
          : null,
      };
    }

    let audioConsumer = null;
    let videoConsumer = null;

    for (const id in consumers) {
      const consumer = consumers[id];
      if (consumer.peerId === email && consumer.track) {
        if (consumer.kind === "audio") {
          audioConsumer = consumer;
        } else if (
          consumer.kind === "video" &&
          !consumer.appData?.share
        ) {
          videoConsumer = consumer;
        }
      }
    }

    let audio = null;
    let video = videoConsumer
      ? { track: videoConsumer.track, locallyPaused: videoConsumer.paused }
      : null;

    if (myTableEmails.includes(email)) {
      audio = audioConsumer
        ? { track: audioConsumer.track, locallyPaused: audioConsumer.paused }
        : null;
    }

    return { audio, video };
  };

  const handleExpand = (tableData: any) => {
    setSelectedTable(tableData); // Store the selected table data
    setView(false); // Switch to grid view
  };

  return (
    <>
      {view ? (
        <div className="text-white w-full">
          {/* <div className="flex flex-col w-full justify-center mt-5 mobile:mt-2">
            <Trainer videoHeight={150} videoWidth={250} name={trainer?.fullname} trainerTableName="On Table 1" />
          </div> */}
          <div className="absolute top-[2%] left-0 m-2 z-50 mobile:w-full laptop:hidden largescreen:hidden tablet:hidden desktop:hidden">
            <img
              src={Icon.logo}
              alt="Viliyo Logo"
              className="w-14 sm:w-16 md:w-20" // responsive widths
            />

          </div>

          {/* <div className="absolute top-[0.01%] right-[0.01%] z-40 scale-50 sm:scale-100 laptop:hidden largescreen:hidden tablet:hidden desktop:hidden">
            <LogoutControl roomClient={roomClient} />
          </div> */}

          {sortedTables?.map((data: any) => (
            <div key={data?.table_name}>
              <div className="flex justify-center items-center space-x-2 mt-5">
                {data?.seats.filter((seat: any) => seat.seat_number === 2).length > 0 ? (
                  data?.seats
                    .filter((seat: any) => seat.seat_number === 2)
                    .map((seat: any) => {
                      const track = getTrack(seat.participant_email);

                      const hasStream =
                        track &&
                        ((track.video && track.video.track) ||
                          (track.audio && track.audio.track));

                      return hasStream ? (
                        <div key={seat.participant_name}>
                          <div className="flex w-full">
                            <Participant
                              name={seat.participant_name}
                              id={seat.participant_id}
                              // profilePhoto={seat.profilePhoto}
                              size="5"
                              radius="small"
                              kebab={true}
                              video="yes"
                              audio="yes"
                              streamArray={track}
                            />
                          </div>
                        </div>
                      ) : (
                        <NoParticipantPanel key={seat.participant_name} name={seat.participant_name} />
                      );
                    })
                ) : null}

                {data?.seats.filter((seat: any) => seat.seat_number === 3).length > 0 ? (
                  data?.seats
                    .filter((seat: any) => seat.seat_number === 3)
                    .map((seat: any) => {
                      const track = getTrack(seat.participant_email);

                      const hasStream =
                        track &&
                        ((track.video && track.video.track) ||
                          (track.audio && track.audio.track));

                      return hasStream ? (
                        <div key={seat.participant_name}>
                          <div className="flex w-full">
                            <Participant
                              name={seat.participant_name}
                              id={seat.participant_id}
                              // profilePhoto={seat.profilePhoto}
                              size="5"
                              radius="small"
                              kebab={true}
                              video="yes"
                              audio="yes"
                              streamArray={track}
                            />
                          </div>
                        </div>
                      ) : (
                        <NoParticipantPanel key={seat.participant_name} name={seat.participant_name} />
                      );
                    })
                ) : null}

                {/* {data.seats.filter((seat: any) => seat.seat_number === 3)
                  .length > 0 ? (
                  data.seats
                    .filter((seat: any) => seat.seat_number === 3)
                    .map((seat: any) => (
                      <div key={seat.participant_name}>
                        <div className="flex w-full">
                          <Participant
                            name={seat.participant_name}
                            id={seat.participant_id}
                            // profilePhoto={seat.profilePhoto}
                            size="5"
                            radius="small"
                            kebab={true}
                            video="yes"
                            audio="yes"
                            streamArray={getTrack(seat.participant_email)}
                          />
                        </div>
                      </div>
                    ))
                ) : null} */}
              </div>
              <div className="flex justify-center py-2">
                <div className="flex flex-col justify-center space-y-4 mobile:space-y-2">
                  {data?.seats.filter((seat: any) => seat.seat_number === 5).length > 0 ? (
                    data?.seats
                      .filter((seat: any) => seat.seat_number === 5)
                      .map((seat: any) => {
                        const track = getTrack(seat.participant_email);

                        const hasStream =
                          track &&
                          ((track.video && track.video.track) ||
                            (track.audio && track.audio.track));

                        return hasStream ? (
                          <div key={seat.participant_name}>
                            <div className="flex w-full">
                              <Participant
                                name={seat.participant_name}
                                id={seat.participant_id}
                                // profilePhoto={seat.profilePhoto}
                                size="5"
                                radius="small"
                                kebab={true}
                                video="yes"
                                audio="yes"
                                streamArray={track}
                              />
                            </div>
                          </div>
                        ) : (
                          <NoParticipantPanel key={seat.participant_name} name={seat.participant_name} />
                        );
                      })
                  ) : null}
                  {/* {data.seats.filter((seat: any) => seat.seat_number === 5)
                    .length > 0 ? (
                    data.seats
                      .filter((seat: any) => seat.seat_number === 5)
                      .map((seat: any) => (
                        <div key={seat.participant_name}>
                          <div className="flex w-full justify-end">
                            <Participant
                              name={seat.participant_name}
                              id={seat.participant_id}
                              // profilePhoto={seat.profilePhoto}
                              size="5"
                              radius="small"
                              kebab={true}
                              video="yes"
                              audio="yes"
                              streamArray={getTrack(seat.participant_email)}
                            />
                          </div>
                        </div>
                      ))
                  ) : null} */}
                  {data?.seats.filter((seat: any) => seat.seat_number === 7).length > 0 ? (
                    data?.seats
                      .filter((seat: any) => seat.seat_number === 7)
                      .map((seat: any) => {
                        const track = getTrack(seat.participant_email);

                        const hasStream =
                          track &&
                          ((track.video && track.video.track) ||
                            (track.audio && track.audio.track));

                        return hasStream ? (
                          <div key={seat.participant_name}>
                            <div className="flex w-full">
                              <Participant
                                name={seat.participant_name}
                                id={seat.participant_id}
                                // profilePhoto={seat.profilePhoto}
                                size="5"
                                radius="small"
                                kebab={true}
                                video="yes"
                                audio="yes"
                                streamArray={track}
                              />
                            </div>
                          </div>
                        ) : (
                          <NoParticipantPanel key={seat.participant_name} name={seat.participant_name} />
                        );
                      })
                  ) : null}
                  {/* {data.seats.filter((seat: any) => seat.seat_number === 7)
                    .length > 0 ? (
                    data.seats
                      .filter((seat: any) => seat.seat_number === 7)
                      .map((seat: any) => (
                        <div key={seat.participant_name}>
                          <div className="flex w-full">
                            <Participant
                              name={seat.participant_name}
                              id={seat.participant_id}
                              // profilePhoto={seat.profilePhoto}
                              size="5"
                              radius="small"
                              kebab={true}
                              video="yes"
                              audio="yes"
                              streamArray={getTrack(seat.participant_email)}
                            />
                          </div>
                        </div>
                      ))
                  ) : null} */}
                </div>
                <ClusterTable
                  typesOfTable={tableTypes.NETWORKING_MODE}
                  tableName={data?.table_name}
                  setView={() => handleExpand(data)}
                  view={view}
                  tableData={data}
                />
                <div className="flex flex-col justify-center space-y-4 mobile:space-y-2">
                  {data?.seats.filter((seat: any) => seat.seat_number === 6).length > 0 ? (
                    data?.seats
                      .filter((seat: any) => seat.seat_number === 6)
                      .map((seat: any) => {
                        const track = getTrack(seat.participant_email);

                        const hasStream =
                          track &&
                          ((track.video && track.video.track) ||
                            (track.audio && track.audio.track));

                        return hasStream ? (
                          <div key={seat.participant_name}>
                            <div className="flex w-full">
                              <Participant
                                name={seat.participant_name}
                                id={seat.participant_id}
                                // profilePhoto={seat.profilePhoto}
                                size="5"
                                radius="small"
                                kebab={true}
                                video="yes"
                                audio="yes"
                                streamArray={track}
                              />
                            </div>
                          </div>
                        ) : (
                          <NoParticipantPanel key={seat.participant_name} name={seat.participant_name} />
                        );
                      })
                  ) : null}
                  {/* {data.seats.filter((seat: any) => seat.seat_number === 6)
                    .length > 0 ? (
                    data.seats
                      .filter((seat: any) => seat.seat_number === 6)
                      .map((seat: any) => (
                        <div key={seat.participant_name}>
                          <div className="flex w-full">
                            <Participant
                              name={seat.participant_name}
                              id={seat.participant_id}
                              // profilePhoto={seat.profilePhoto}
                              size="5"
                              radius="small"
                              kebab={true}
                              video="yes"
                              audio="yes"
                              streamArray={getTrack(seat.participant_email)}
                            />
                          </div>
                        </div>
                      ))
                  ) : null} */}
                  {data?.seats.filter((seat: any) => seat.seat_number === 8).length > 0 ? (
                    data?.seats
                      .filter((seat: any) => seat.seat_number === 8)
                      .map((seat: any) => {
                        const track = getTrack(seat.participant_email);

                        const hasStream =
                          track &&
                          ((track.video && track.video.track) ||
                            (track.audio && track.audio.track));

                        return hasStream ? (
                          <div key={seat.participant_name}>
                            <div className="flex w-full">
                              <Participant
                                name={seat.participant_name}
                                id={seat.participant_id}
                                // profilePhoto={seat.profilePhoto}
                                size="5"
                                radius="small"
                                kebab={true}
                                video="yes"
                                audio="yes"
                                streamArray={track}
                              />
                            </div>
                          </div>
                        ) : (
                          <NoParticipantPanel key={seat.participant_name} name={seat.participant_name} />
                        );
                      })
                  ) : null}
                  {/* {data.seats.filter((seat: any) => seat.seat_number === 8)
                    .length > 0 ? (
                    data.seats
                      .filter((seat: any) => seat.seat_number === 8)
                      .map((seat: any) => (
                        <div key={seat.participant_name}>
                          <div className="flex w-full">
                            <Participant
                              name={seat.participant_name}
                              id={seat.participant_id}
                              // profilePhoto={seat.profilePhoto}
                              size="5"
                              radius="small"
                              kebab={true}
                              video="yes"
                              audio="yes"
                              streamArray={getTrack(seat.participant_email)}
                            />
                          </div>
                        </div>
                      ))
                  ) : null} */}
                </div>
              </div>
              <div className="flex justify-center space-x-2">
                {data?.seats.filter((seat: any) => seat.seat_number === 1).length > 0 ? (
                  data?.seats
                    .filter((seat: any) => seat.seat_number === 1)
                    .map((seat: any) => {
                      const track = getTrack(seat.participant_email);

                      const hasStream =
                        track &&
                        ((track.video && track.video.track) ||
                          (track.audio && track.audio.track));

                      return hasStream ? (
                        <div key={seat.participant_name}>
                          <div className="flex w-full">
                            <Participant
                              name={seat.participant_name}
                              id={seat.participant_id}
                              // profilePhoto={seat.profilePhoto}
                              size="5"
                              radius="small"
                              kebab={true}
                              video="yes"
                              audio="yes"
                              streamArray={track}
                            />
                          </div>
                        </div>
                      ) : (
                        <NoParticipantPanel key={seat.participant_name} name={seat.participant_name} />
                      );
                    })
                ) : null}
                {/* {data.seats.filter((seat: any) => seat.seat_number === 1)
                  .length > 0 ? (
                  data.seats
                    .filter((seat: any) => seat.seat_number === 1)
                    .map((seat: any) => (
                      <div
                        key={seat.participant_name}
                        className={` ${seat.seat_number === 1 && "flex justify-center "}`}
                      >
                        <div className="flex w-full">
                          <Participant
                            name={seat.participant_name}
                            id={seat.participant_id}
                            // profilePhoto={seat.profilePhoto}
                            size="5"
                            radius="small"
                            kebab={true}
                            video="yes"
                            audio="yes"
                            streamArray={getTrack(seat.participant_email)}
                          />
                        </div>
                      </div>
                    ))
                ) : null} */}

                {data?.seats.filter((seat: any) => seat.seat_number === 4).length > 0 ? (
                  data?.seats
                    .filter((seat: any) => seat.seat_number === 4)
                    .map((seat: any) => {
                      const track = getTrack(seat.participant_email);

                      const hasStream =
                        track &&
                        ((track.video && track.video.track) ||
                          (track.audio && track.audio.track));

                      return hasStream ? (
                        <div key={seat.participant_name}>
                          <div className="flex w-full">
                            <Participant
                              name={seat.participant_name}
                              id={seat.participant_id}
                              // profilePhoto={seat.profilePhoto}
                              size="5"
                              radius="small"
                              kebab={true}
                              video="yes"
                              audio="yes"
                              streamArray={track}
                            />
                          </div>
                        </div>
                      ) : (
                        <NoParticipantPanel key={seat.participant_name} name={seat.participant_name} />
                      );
                    })
                ) : null}
                {/* {data.seats.filter((seat: any) => seat.seat_number === 4)
                  .length > 0 ? (
                  data.seats
                    .filter((seat: any) => seat.seat_number === 4)
                    .map((seat: any) => (
                      <div
                        key={seat.participant_name}
                        className={`${seat.seat_number === 4 && "flex justify-center "}`}
                      >
                        <div className="flex w-full">
                          <Participant
                            name={seat.participant_name}
                            id={seat.participant_id}
                            // profilePhoto={seat.profilePhoto}
                            size="5"
                            radius="small"
                            kebab={true}
                            video="yes"
                            audio="yes"
                            streamArray={getTrack(seat.participant_email)}
                          />
                        </div>
                      </div>
                    ))
                ) : null} */}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="w-full h-full">
          {/* <div className="flex flex-col w-full justify-center mt-5 mobile:mt-6">
            <Trainer videoHeight={150} videoWidth={250} name={trainer?.fullname} trainerTableName="On Table 1" />
          </div> */}
          <ParticipantExpandedView
            view={() => {
              setView(true);
              setSelectedTable(null); // Reset selected table when switching back
            }}
            tableDetails={selectedTable ? [selectedTable] : []}
          />
        </div>
      )}
    </>
  );
};

export default ClusterTableSittingAlignment;